import type React from "react"

export const Ellipsis: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="5"
    height="17"
    viewBox="0 0 5 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Ellipsis</title>
    <path
      d="M2.5 12.875C3.51562 12.875 4.375 13.7344 4.375 14.75C4.375 15.8047 3.51562 16.625 2.5 16.625C1.44531 16.625 0.625 15.8047 0.625 14.75C0.625 13.7344 1.44531 12.875 2.5 12.875ZM2.5 6.625C3.51562 6.625 4.375 7.48438 4.375 8.5C4.375 9.55469 3.51562 10.375 2.5 10.375C1.44531 10.375 0.625 9.55469 0.625 8.5C0.625 7.48438 1.44531 6.625 2.5 6.625ZM2.5 4.125C1.44531 4.125 0.625 3.30469 0.625 2.25C0.625 1.23438 1.44531 0.375 2.5 0.375C3.51562 0.375 4.375 1.23438 4.375 2.25C4.375 3.30469 3.51562 4.125 2.5 4.125Z"
      fill="#938F94"
    />
  </svg>
)
